import React, { useState, useEffect, useRef, useContext } from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import OrderStage from 'components/OrderStage'
import OrderActionsButton from './../OrderActionsButton'
import messages from './messages'
import { Chip } from '@arnsbogroup/react-voicearchive'
import { BrandContext } from 'CustomerApp'

const Components = {
  Text: ({ value }) => (
    <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
      { value }
    </td>
  ),
  SpotDuration: ({ value }) => (
    <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
      { value }
    </td>
  ),
}

const OrderRow = ({ compact = false, order, columns, onClick, isSelected }) => {
  const [showDetailsPane, setShowDetailsPane] = useState(false)
  const { brand } = useContext(BrandContext)

  let { stage, uid, crdate, deadline, customer_name, name, customerReference, contact_name, contact_email, contact_image, orderusage_name, medias, order_template_uid } = order

  if (!contact_email) {
    contact_name = 'Not assigned'
    contact_email = '-'
  }

  return (
    <tr
      key={uid}
      className={`py-2 ${stage == 'AMENDING' ? 'bg-yellow-50 hover:bg-yellow-100' : 'hover:bg-gray-100'} cursor-pointer border-b border-gray-100 ${isSelected ? 'shadow-inner bg-blue-100' : ''}`}
      onClick={onClick}
      tabIndex={0}
    >
      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <span>#{ uid }</span>
      </td>

      { !compact &&
        <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate text-gray-200">
          { customerReference ? (
            <span className="text-gray-900">{ customerReference }</span>
          ) : (
            <span className="text-gray-200">
              <FormattedMessage {...messages.notSupplied} />
            </span>
          ) }
        </td>
      }

      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <FormattedDate value={new Date(crdate * 1000)} />
      </td>

      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        <FormattedDate value={new Date(deadline * 1000)} />
      </td>

      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
        { name }
      </td>

      <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm text-gray-400">
        <OrderStage stage={stage} />
      </td>

      { !compact &&
        <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm truncate">
          { customer_name }
        </td>
      }

      { !compact &&
        <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap truncate" title={`${contact_name} (${contact_email})`}>
          <div className="flex items-center w-full truncate justify-center xl:justify-start">
            <div className="shrink-0 h-8 w-8">
              { contact_image ? (
                <img className="h-8 w-8 rounded-full" src={contact_image} alt="" />
              ) : (
                <div className="w-8 h-8 block rounded-full bg-gray-200 flex justify-center items-center">
                  <Icon icon="user" />
                </div>
              ) }
            </div>
            <div className="ml-4 hidden xl:block truncate">
              <div className="text-sm font-medium text-gray-900 truncate">
                { contact_name }
              </div>
              <div className="text-sm text-gray-500 truncate">
                { contact_email }
              </div>
            </div>
          </div>
        </td>
      }

      { !compact &&
        <td className="px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm space-y-1">
          <div className='flex gap-1 flex-wrap'>
            {!!orderusage_name &&
                <Chip>{orderusage_name}</Chip>
            }
            {medias && !!medias.length && medias.map(({name}) => 
              <Chip>{name}</Chip>
            )}
          </div>
        </td>
      }

      { !compact && columns.map(({ key, component })  => (
        React.createElement(Components[component], {
          key: `${key}-${uid}`,
          value: order[key]
        })
      )) }

      { compact ? (
        <td className="px-1 xl:px-4 py-2 xl:py-3 text-right">
          <Icon icon="long-arrow-right" />
        </td>
      ) : (
        <td className="px-1 xl:px-4 py-2 xl:py-3">
          { (brand.voiceflow && order_template_uid) ? (
            <div className="w-full h-full flex items-center justify-end">
              <OrderActionsButton id={uid} />
            </div>
          ) : (
            <Icon icon="chevron-right" />
          ) }
        </td>
      ) }
    </tr>
  )
}

export default OrderRow
